import React, {useContext, useEffect, useState} from 'react';

export const ThemeContext = React.createContext();

export const THEMES = {
    default: 'Weiß',
    // white: 'Weiß',
    lothar: 'Weiß',
    green: 'Grün'
}

export const ThemeProvider = ({ children }) => {

    const [theme, setTheme] = useState( THEMES.lothar )

    const _setTheme = ( value ) => {
        if( value !== theme )
            setTheme( value )
    }

    const getCSS = () => {
        console.log( "switch theme", theme )
        switch( theme ){
            case THEMES.white:
                return window.location.protocol + '//' + window.location.host + '/Theme-WHITE.css'
            case THEMES.green:
                return window.location.protocol + '//' + window.location.host + '/Theme-IT.css'
            case THEMES.lothar:
            default:
                return window.location.protocol + '//' + window.location.host + '/Theme-LOTHAR.css'

        }
    }

    return <ThemeContext.Provider value={{
        setTheme: _setTheme,
        currentTheme: theme,
        css: getCSS
    }}>
        { children }
    </ThemeContext.Provider>
}